import { PlusOutlined } from "@ant-design/icons";
import { Drawer, Layout } from "antd";
import { useState } from "react";
import React from "react";

const BigDrawer = ({ children, btnTitle, title, className, width, drawer, onClose: onCloseProp }) => {
  const { Content } = Layout;
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    // Call the onClose prop if provided (for refreshing data)
    if (onCloseProp) {
      onCloseProp();
    }
  };
  
  // Clone children to pass onClose callback
  const childrenWithProps = React.cloneElement(children, { 
    onClose: handleClose,
    drawer: drawer || true 
  });
  
  return (
    <>
      <button
        className={`mx-1 flex justify-center items-center bg-primary  rounded p-1 gap-1 text-white ${
          className ? className : ""
        }`}
        type="button"
        onClick={showDrawer}>
        <PlusOutlined className="text-[10px] flex items-center" />
        {btnTitle}
      </button>
      <Drawer
        title={`Create ${title}`}
        width={window.innerWidth <= 768 ? "100%" : width ? `${width}%` : "40%"}
        onClose={handleClose}
        open={open}
        bodyStyle={{
          paddingBottom: 80,
        }}>
        <Content>{childrenWithProps}</Content>
      </Drawer>
    </>
  );
};
export default BigDrawer;
